module.exports = __webpack_public_path__ + "static/CloudflarePerformance-5f92b2e7c349cb7f89f3b42869d31a7a.png";